import VisibilityIcon from "@mui/icons-material/Visibility";
import { SvgIconProps } from "@mui/material";

export const Visibility = (props: SvgIconProps) => {
  return <VisibilityIcon data-testcomp="Icon_Visibility" {...props} />;
};
